import { SuperTokensConfig } from 'supertokens-web-js/lib/build/types'
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import Session from 'supertokens-web-js/recipe/session'
import ThirdParty from 'supertokens-web-js/recipe/thirdparty'

export default function superTokensConfig(): SuperTokensConfig {
  return {
    appInfo: {
      apiDomain: process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI!,
      apiBasePath: '/auth',
      appName: 'codegen',
    },
    recipeList: [Session.init(), EmailPassword.init(), ThirdParty.init()],
  }
}
